import axios from "axios";
import React from "react";
import _ from "lodash";
import { useNavigate } from 'react-router-dom';
import BallotComponent from "../components/BallotComponent";
import { BallotContext } from "../context/BallotContext";
import BallotInterface from "../interfaces/ballotInterface";
import GlobalState from "../interfaces/globalState";
import { StateContext } from "../context/StateContext";

export const client = axios.create({
  baseURL: process.env.REACT_APP_HOST,
});

export default function Voting() {

  const queryParameters = new URLSearchParams(window.location.search)
  const sID = queryParameters.get("showID") ?? "undefined"

  const navigate = useNavigate();

  const defaultBallot: BallotInterface = {
    id: "",
    description: "Hello welcome to DANCExDANCE",
    acceptUserInput: false,
    prompts: [],
  };
  
  const defaultState: GlobalState = {
    fade: false,
  };
  
  const [currentBallot, _setCurrentBallot]: [BallotInterface, any] =
  React.useState(defaultBallot);
  
  const [currentState, _setGlobalState]: [GlobalState, any] =
  React.useState(defaultState);
  
  // This confusing syntax exists to ensure that the setcurrentballot only actually gets called when the new polled ballot is different from the existing current ballot
  // if we keep re-writing the current ballot, the BallotComponent will keep re-rendering. Not a big issue in this app, but this re-rendering is not good for performance in general
  // see: https://stackoverflow.com/a/70712897/9533616
  const setCurrentBallot = (bal: BallotInterface) => {
    _setCurrentBallot((prev) => {
      if (!_.isEqual(bal, prev)) {
        return bal;
      }
      return prev;
    });
  };
  
  const setGlobalState = (gstate: GlobalState) => {
    _setGlobalState((prev) => {
      if (!_.isEqual(gstate, prev)) {
        console.log("Global state changed");
        return gstate;
      }
      return prev;
    });
  };
  
  // error and loading states
  const [loading, setLoading]: [boolean, (loading: boolean) => void] =
  React.useState<boolean>(true);
  const [error, setError]: [string, (error: string) => void] =
  React.useState("");
  
  // Polls the new current ballot. Split into it's own function because we use 
  // the same code twice: the very first poll and the regular interval polls
  // Note: we include the show ID ... for MWSM...
  function getCurrentBallot() {
    client
    .get<BallotInterface>("/ballots/currentforshowid/" + sID, { timeout: 10000 })
    .then((response) => {
      setCurrentBallot(response.data);
      setLoading(false);

      console.log("getCurrentBallot(): " + response.data.id)

      // HARDCODE - move to Postshow page on ballot 1026
      if(response.data.id == "1026") {
        navigate('/postshowquestions?showID=' + sID)
      }
    })
    .catch((ex) => {
      const error = " "
    //   ex.code === "ECONNABORTED"
    //   ? "A timeout has occurred"
    //   : ex.response.status === 404
    //   ? "Resource Not found"
    //   : "An unexpected error has occurred";
      setError(error);
      setLoading(false);
    });
  }
  
  //
  // There is a weird timing bug in here I think. sometimes in special case section it "loses" 
  // the current ballot (goes back to null/blank) even though the rest of the page is
  // correctly showing the ballot. The impact is that for patrons wainting for their show
  // to start the screen is blank most of the time except when the fade state is false...
  // Living with it for now...
  //
  function getGlobalState() {
    console.log("getGlobalState called")
    client
    .get<GlobalState>("/mysecretkey/fadestate", { timeout: 10000 })
    .then((response) => {

      // trying this...
      // doesn't seem to work...
      if ("" + currentBallot.id == "") {
        console.log("getGlobalState(): no ballot... calling getCurrentBallot")
        getCurrentBallot()
      }

      if (currentBallot.id == "1000") {
        // Special case - don't fade initial prompt
        setGlobalState({fade: false})
        console.log("getGlobalState: special case: false")
      } else {
        setGlobalState(response.data);
        console.log("getGlobalState: reg case: " + currentBallot.id + ", " + response.data.fade)
      }
      setLoading(false);
      
    })
    .catch((ex) => {
      const error = " "
    //   ex.code === "ECONNABORTED"
    //   ? "A timeout has occurred"
    //   : ex.response.status === 404
    //   ? "Resource Not found"
    //   : "An unexpected error has occurred";
      setError(error);
      setLoading(false);
    });

  }
  
 
  
  React.useEffect(() => {
    // poll the current ballot for the first time
    getCurrentBallot();
    getGlobalState();
    
    // run timer at regular intervals to get new current ballot
    // DEBUG - set to 5 sec
    // Normally - 1 sec but trying 2 sec for show... poss timing issue with getting fade state
    const timer = setInterval(() => {
      console.log("setInterval calling getCurrentBallot ad getGlobalState")
      getCurrentBallot();
      getGlobalState();
    }
    , 2000);
    return () => clearInterval(timer);
  }, []);
  
  
  
  return (
      <StateContext.Provider value={{ currentState, setGlobalState }}>
        <BallotContext.Provider value={{ currentBallot, setCurrentBallot }}>
          <BallotComponent />

          {error && <p className="error">{error}</p>}
         {loading && <p>Loading</p>}

        </BallotContext.Provider>
      </StateContext.Provider>
    );
  }
